import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { workflowStepSchema } from '../models/workflowStep.schema';
import { workflowStepsListQuerySchema } from './list.schema';

export type WorkflowStepsListQuery = Partial<{
  workflow: ID;
  id: ID | ID[];
}> &
  PaginationQuery;

export const list = (query: WorkflowStepsListQuery = {}) => {
  return {
    endpoint: `/workflow_steps`,
    method: 'GET',
    responseSchema: listResponse(workflowStepSchema),
    query: { ...query, includeTotal: true },
    querySchema: workflowStepsListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
